const choices = {
    notImportant: 'A priori non',
    important: 'Peut-être',
    highlyImportant: 'Certainement',
};

export default choices;
